import { z } from 'zod';

import { responsiveSchema } from '../../../../utils';
import { widgetBaseSchema } from '../../../common/schemas/base';
import { INDENT_HEIGHT_BOUNDS } from '../legacy/styles';

/**
 * Indent (spacer) settings, v0. The field names are the legacy ones: `height` is
 * per breakpoint at the leaf (legacy `styles.height` → `desktop`,
 * `mobileStyles.height` → `mobile`), and the sync switch stays flat — it has no
 * meaning per breakpoint.
 *
 * A spacer persisted before the per-device height shipped has no `mobile` leaf;
 * renderers then fall back to the desktop one.
 */
export const indentDefaultDataSchema = z.object({
    /** Write desktop height edits through to mobile. */
    syncWithDesktop: z.boolean(),
    height: responsiveSchema(z.number().meta(INDENT_HEIGHT_BOUNDS)),
});

export const indentDefaultSchema = widgetBaseSchema.extend({
    entityType: z.literal('widget:indent'),
    entitySubType: z.literal('default'),
    props: indentDefaultDataSchema,
    version: z.literal(0),
});

export const indentDefaultV0Schema = indentDefaultSchema;
export type IndentDefaultV0 = z.infer<typeof indentDefaultV0Schema>;
